import apiClient from "../../../utils/apiClient";

export const getVaccinationGroups = (
    testCenter
) => {
  return apiClient.get(`/public/vaccinationGroups/`, {
    params: { testCenter }
  });
};
